<template>
  <div style="width: 1200px; margin: auto">
    <div class="top">
      <el-image :src="img" fit="fill" class="serviecbanner">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
    </div>
    <div v-if="null!=details" class="details" v-html="details"></div>

    <div class="demand-form min1200">
      <div class="main">
        <el-form
          ref="form"
          :model="form"
          label-width="140px"
          :rules="validateRule"
        >
          <div v-for="(item, index) in form.formData" :key="index">
            <el-form-item :label="item.fieldName + '：'" :prop="item.property">
              <!-- 输入框 -->
              <el-input
                v-if="item.type == 'input'"
                v-model="form[`${item.property}`]"
                :placeholder="'请输入' + item.fieldName"
                style="width: 80%"
              ></el-input>
              <span v-if="item.type == 'input'">{{ item.unit }}</span>

              <!-- select框 -->
              <el-select
                v-if="item.type === 'select'"
                style="width: 80%"
                v-model="form[`${item.property}`]"
                :placeholder="'请输入' + item.fieldName"
              >
                <el-option
                  v-for="item in item.selectData"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictLabel"
                >
                </el-option>
              </el-select>
              <span v-if="item.type === 'select'">{{ item.unit }}</span>

              <!--单选框 -->
              <el-radio-group
                v-model="form[`${item.property}`]"
                v-if="item.type === 'radio'"
              >
                <el-radio
                  v-for="(item, index) in item.radioData"
                  :label="item.dictLabel"
                  :key="index"
                  :value="item.dictCode"
                  >{{ item.dictLabel }}</el-radio
                >
              </el-radio-group>

              <!-- 多选框 -->
              <el-checkbox-group
                v-model="form[`${item.property}`]"
                v-if="item.type == 'checkbox'"
              >
                <el-checkbox
                  v-for="(databox, indexbox) in item.checkBoxData"
                  :key="indexbox"
                  :label="databox.dictLabel"
                  >{{ databox.dictLabel }}</el-checkbox
                >
              </el-checkbox-group>

              <!-- 级联 -->
              <el-cascader
                v-if="item.type === 'area'"
                style="width: 80%"
                v-model="form[`${item.property}`]"
                ref="cascaderAddr"
                class="projectAddress"
                :placeholder="'请输入' + item.fieldName"
                :props="{ checkStrictly: true }"
                :options="getprovince"
                @change="areaHandleChange(item, index)"
              >
              </el-cascader>
              <!-- 日期 -->

              <el-date-picker
                v-if="item.type === 'datebox'"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="'请选择' + item.fieldName"
                v-model="form[`${item.property}`]"
                style="width: 80%"
              ></el-date-picker>
            </el-form-item>
          </div>

          <!-- <div v-if="form.formData.length == 0" class="no">暂无数据请在后台添加</div> -->
        </el-form>
        <el-button
          v-if="form.formData.length !== 0"
          type="primary"
          style="display: block; margin: 0 auto;margin-bottom: 20px;"
          @click="onSubmit"
          >提交需求</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { getfields, details, Servicecommit } from "@/api/xunyou";
import indexVue from "../brand/index.vue";
export default {
  data() {
    return {
      
      validateRule: {
        phone: [
          {
            required: true,
            message: "请输入活动名称",
            trigger: "blur",
          },
        ],
      },
      form: {
        formData: [],
      },
      img: "",
      details: "",
      flage: 0,
      flage2: 0,
      type: 1,
      type2: 1,
      topicId: null,
      pageType: null,
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      checkboxDictType: "",
      radioDictType: "",
      selectDictType: "",
      loading: false,
      radioData: [],
      checkboxData: [],
      selectData: [],
      indexNum: 0, //定义一级菜单的下标
      rules: {},
      address: "",
    };
  },
  computed: {
    ...mapState(["getprovince"]),
  },
  created() {
    this.topicId = this.$route.query.topicId;
    this.pageType = this.$route.query.pageType;
    this.datalist();
    this.handleImg();
  },
  mounted() {},
  methods: {
    //查询信息
    datalist() {
      getfields({
        topicId: this.$route.query.topicId,
      }).then((res) => {
        // debugger
        if (res.data.length !== 0) {
          let data = res.data;
          data.forEach((item) => {
            if (item.type === "checkbox") {
              item.checkboxData = item.checkBoxData;
              this.$set(this.form, item.property, []); // 通过$set定义初始值（可实现双向绑定）
            }
            item.validateRule = item.validateRule || "{}";
            if (item.validateRule != "{}") {
              item.validateRule = JSON.parse(item.validateRule);
              this.validateRule[item.property] = item.validateRule;
            }
            console.log("wb0", item.validateRule);
            console.log("wb1", this.validateRule);
          });

          this.form.formData = data;
          console.log("wb2", data);
          // this.$forceUpdate()
        } else {
          this.form.formData = [];
          this.$message({
            showClose: true,
            message: "暂无表单数据,请去后台添加",
          });
        }
      });
    },
    //查询图片
    handleImg() {
      details({
        id: this.$route.query.topicId,
      }).then((res) => {
        if (res.code == 0) {
          this.img = res.data.img;
          this.details = res.data.details;
        } else {
          this.img = require("@/assets/images/serviesbj.jpg");
        }
        console.log(res, "Res");
      });
    },
    // 填写地址选择
    areaHandleChange(item, index) {
      this.$nextTick(() => {
        let label = this.$refs.cascaderAddr[0].$refs.panel.getCheckedNodes();
        if (label[0].pathLabels[2] == undefined) {
          this.address = label[0].pathLabels[0] + "/" + label[0].pathLabels[1];
        } else {
          this.address =
            label[0].pathLabels[0] +
            "/" +
            label[0].pathLabels[1] +
            "/" +
            label[0].pathLabels[2];
        }
      });
    },
    onSubmit() {
      // debugger;
      this.$refs.form.validate((valid) => {
        if (valid) {
          var formArr = [];

          this.form.formData.forEach((item) => {
            let arr = {};
            arr[item.property] =
              item.searchValue == "" || item.searchValue == null
                ? this.form[item.property]
                : item.searchValue;

            formArr.push(arr);
          });

          formArr.forEach((item) => {
            item[item.property] = item.searchValue;
            delete item.property;
            delete item.searchValue;
          });
          let listObj = formArr.reduce((acc, value) => {
            return { ...acc, ...value };
          });
          let formadd = {
            _address: this.address,
            ...listObj,
          };
          let serviceObj = {
            pageType: Number(this.pageType),
            userId: this.userInfo.userId,
            topicId: Number(this.topicId),
            content: JSON.stringify(formadd),
          };

          Servicecommit(serviceObj)
            .then((res) => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "添加成功!",
                });

                this.form.formData.map((item) => {
                  item.searchValue = "";
                });
                this.$router.go(-1);
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("添加失败");
            });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>

.no {
  font-size: 20px;
  text-align: center;
}

body {
  color: #686868 !important;
}

// banner图
.min1200 {
  width: 1200px;
  margin: auto;
}

a {
  color: #727272;
  text-decoration: none;
}

.top {
  margin-top: 10px;
  .serviecbanner {
    width: 1200px;
    height: 260px;
  }
}

//下方
.demand-form {
  margin: 0 auto;
  z-index: 1;
  background: #fff;
  box-shadow: 0px 2px 15px 0px #d7d7d7;
  border: solid 1px #e5e5e5;
  position: relative;
}

/deep/.el-form-item__label {
  font-size: 14px;
  color: #333;
}

/deep/.cancel {
  float: right;
  margin-top: 0px !important;
  cursor: pointer;
  color: black;
}

.main {
  padding-top: 20px;
  width: 60%;
  margin: auto;
}

.more {
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
  font-size: 12px;
  cursor: pointer;
}

.details {
  background: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  padding: 10px 20px;

  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/serviceGoods/index.vue